module.exports = __webpack_public_path__ + "img/coupon-2.b5715db6.png";